import auditLogService from '../../services/api/AuditLog';
import commonFunctions from '../../mixin/common-function-mixins';
import {AUDIT_LOG_SUMMARY_ACTION}  from '../action-types';
import {AUDIT_LOG_SUMMARY_MUTATION, AUDIT_LOG_START_DATE_CHANGED_MUTATION, AUDIT_LOG_END_DATE_CHANGED_MUTATION,
    AUDIT_LOG_CATEGORY_CHANGED_MUTATION, AUDIT_LOG_UNIDENTIFIER_CHANGED_MUTATION, AUDIT_LOG_CLEAR_DATA_MUTATION,
    AUDIT_LOG_CLEAR_SUMMARY_DATA_MUTATION} from '../mutation-types';

// initial state
export const namespaced = true;
export const state = {
    namespaced: true,
    auditLogSummaryData: [],
    auditLogData: loadEmptyAuditLog()

};
// actions
export const actions = {  
    async [AUDIT_LOG_SUMMARY_ACTION]({ commit },value) {
        const response = await auditLogService.getAuditLogSummary(value);
        commit(AUDIT_LOG_SUMMARY_MUTATION, response.data);
        return response;
    }
}

// mutations
export const mutations = { 
    [AUDIT_LOG_SUMMARY_MUTATION](state, auditLogSummaryData){
        state.auditLogSummaryData = [];
        auditLogSummaryData.map(r =>{ r.logTimeStamp = commonFunctions.methods.formatDate(r.logTimeStamp, 'MM/DD/YYYY hh:mm A')});
        state.auditLogSummaryData = commonFunctions.methods.sortRecords(auditLogSummaryData, 'ptCreatedDate', false);
    },
    [AUDIT_LOG_START_DATE_CHANGED_MUTATION](state, startDate){
        state.auditLogData.startDate = startDate;
    },
    [AUDIT_LOG_END_DATE_CHANGED_MUTATION](state, endDate){
        state.auditLogData.endDate = endDate;
    },
    [AUDIT_LOG_CATEGORY_CHANGED_MUTATION](state, category){
        state.auditLogData.category = category;
    },
    [AUDIT_LOG_UNIDENTIFIER_CHANGED_MUTATION](state, uniqueIdentifier){
        state.auditLogData.uniqueIdentifier = uniqueIdentifier;
    },
    [AUDIT_LOG_CLEAR_DATA_MUTATION](state){
        state.auditLogData = loadEmptyAuditLog();
    },
    [AUDIT_LOG_CLEAR_SUMMARY_DATA_MUTATION](state){
        state.auditLogSummaryData = [];
    }

}       


function loadEmptyAuditLog(){
    return {
        startDate: '',
        endDate: '',
        category: '',
        uniqueIdentifier: ''
    }
}